<template>
  <div
    class="m-dropdown-content m-dropdown-content-left"
    :id="`MoleculeEditionMapChartBoardDropDownProgress-${indexR}-${indexC}`"
  >
    <section
      class="m-dropdown-section"
    >
      <ul class="m-dropdown-list">
        <li
          v-for="item in studentsProgress"
          :key="item.id ? item.id : item.alumno"
        >
          <span class="item-data">
            <img
              class="a-avatar-primary"
              :src="item.avatar ? item.avatar : (item.logo ? item.logo : require('@/assets/img/avatar.png'))"
            />
            <span class="ellipsis width-150-px">
              {{ item.razon_social ? item.razon_social : item.nombre }}
            </span>
          </span>
          <span class="item-points">
            {{ item.puntos }}
            <i class="fas fa-star text-color-notifications-primary"></i>
          </span>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapChartBoardDropDownProgress',

  props: {
    indexC: {
      type: [Number, String],
      default: null
    },

    indexR: {
      type: [Number, String],
      default: null
    },

    studentsProgress: {
      type: Array,
      default: () => ([])
    }
  }
}
</script>
